export default __webpack_public_path__ + "static/media/tree.746d5acd.png";